import { configureStore } from "@reduxjs/toolkit";
import courseSlice from "./reducers/courseSlice";
import userSlice from "./reducers/userSlice";

export const store = configureStore({
  reducer: {
    course: courseSlice,
    user: userSlice,
  }
})